import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { usePermissions } from "../context/permissionContext";
import Loader from "../components/Loader/Loader";
import { validatePermission } from "../utils/permissionUtils";

function ProtectedRoutes({ requiredPath, children }) {
  const { permissions, permissionsMapping, loading } = usePermissions();
  const [hasPermission, setHasPermission] = useState(null);
  const [auth, setAuth] = useState(!!localStorage.getItem("accessToken"));

  // Handle auth state changes
  useEffect(() => {
    const checkAuth = () => {
      const newAuth = !!localStorage.getItem("accessToken");
      if (newAuth !== auth) {
        setAuth(newAuth);
      }
    };
    window.addEventListener("storage", checkAuth);
    return () => window.removeEventListener("storage", checkAuth);
  }, [auth]);

  // Handle permission validation
  useEffect(() => {
    if (!auth) {
      setHasPermission(false);
      return;
    }

    if (!loading && permissions && permissionsMapping) {
      const permission = validatePermission(requiredPath, permissions, permissionsMapping);
      setHasPermission(permission);
    }
  }, [loading, auth, requiredPath, permissions, permissionsMapping]);

  if (!auth) {
    return <Navigate to="/login" replace />;
  }

  if (loading || hasPermission === null) {
    return <Loader isLoading={true} />;
  }

  return hasPermission ? children : <Navigate to="/permission" replace />;
}

export default ProtectedRoutes;
